import { Component, input } from '@angular/core';
import { BaseConfigurableComponent } from '@app/base-config.component';

@Component({
  selector: 'afcu-empty-search',
  standalone: true,
  imports: [],
  templateUrl: './empty-search.component.html',
  styleUrl: './empty-search.component.css'
})
export class EmptySearchComponent extends BaseConfigurableComponent {

  target = input.required<string>()

  constructor(){
    super('noFound')
  }
}
